import { useGetImportantDays } from './useGetImportantDays';
import { useCallback } from 'react';

type entity = 'tasks' | 'signing-appointments';

export const useDetermineStartDateEndDateParams = (): ((
  tabId: string,
  entity: entity
) => { startDate?: string; endDate?: string }) => {
  const { today, tomorrow, dayAfterTomorrow, startWeek, endWeek } = useGetImportantDays();
  return useCallback(
    (tabId: string, entity: entity) => {
      if (tabId === `due-today-${entity}-tab`) {
        return { startDate: today, endDate: tomorrow };
      }
      if (tabId === `due-tomorrow-${entity}-tab`) {
        return {
          startDate: tomorrow,
          endDate: dayAfterTomorrow,
        };
      }
      if (tabId === `due-this-week-${entity}-tab`) {
        return { startDate: startWeek, endDate: endWeek };
      }
      if (tabId === `past-due-${entity}-tab`) {
        return { endDate: today };
      }
      return {};
    },
    [today, tomorrow, dayAfterTomorrow, startWeek, endWeek]
  );
};
